import React from "react";
import styles from './Spinner.module.css'

export default class Spinner extends React.Component {

    render() {
        const classes = this.props.classes ? this.props.classes : "";

        let style = this.props.style ? this.props.style : {}
        style.textAlign = "center"
        style.color = "white"
        style.zIndex = "150"

        return (
            <>
                <div className={styles.spinnerContainer}>
                    <div
                        className={styles.spinner.concat(" progress-spinner progress-spinner-active ".concat(classes))}/>
                    <p style={style}>{this.props.text}</p>
                </div>

            </>
        );
    }

}
Spinner.defaultProps = {
    text: "Caricamento...",

}
